<div class="container">
  <app-vod-player [config]="vodplayerconfig"></app-vod-player>
</div>
